module.exports = __webpack_public_path__ + "img/600.78aa4123.svg";